var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#D68A55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#324A5E",
    d: "M18 12.217L5.754 10.205c-.113-.029-.198.056-.198.17V26.05c0 .085.057.17.142.17L18 28.233V12.217z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CED5E0",
    d: "M18 12.813L6.208 10.885v14.854L18 27.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#324A5E",
    d: "M18 12.217l12.246-2.012c.113-.029.198.056.198.17V26.05c0 .085-.057.17-.142.17L18 28.233V12.217z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACB3BA",
    d: "M18 12.813l11.792-1.928v14.854L18 27.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CED5E0",
    d: "M28.63 10.091c-3.402-.963-7.427.029-10.63 2.75v14.825c3.203-2.721 7.228-3.742 10.63-2.75V10.092z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#E6E9EE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.496 7.767C24.463 7.54 20.863 9.41 18 12.84v14.825c2.863-3.43 6.463-5.3 9.496-5.074V7.767zM7.37 10.091c3.402-.963 7.427.029 10.63 2.75v14.825c-3.203-2.721-7.228-3.742-10.63-2.75V10.092z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.504 7.767C11.537 7.54 15.137 9.41 18 12.84v14.825c-2.863-3.43-6.463-5.3-9.496-5.074V7.767z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.481e6748573d6b991e37cba748c3e07d.svg";
export { ForwardRef as ReactComponent };